module.exports = __webpack_public_path__ + "img/shoucangjia.c7a2ce72.png";